import React, { useState, useEffect, useRef } from 'react';
import 'swiper/swiper-bundle.css';
import 'swiper/css/navigation';
import { db } from '../../../js/firebase';
import { doc, getDoc } from 'firebase/firestore';
import { gsap } from 'gsap';

import { IntentionGraphic, IdentificationGraphic, IntegrationGraphic, ImplementationGraphic, WhoGraphic } from '../../shared/icons/InfoPageGraphics';

import * as styles from './About.module.scss';
import AboutSections from '../AboutSections/AboutSections';
import { Link } from 'react-router-dom';

const About = ({ parentScroller, openServices }) => {
  const aboutRef = useRef(null);
  // const footerRef = useRef(null);
  const animatedContentRef = useRef(null);

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [sections, setSections] = useState([]);
  const [aboutText, setAboutText] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  const [activeSection, setActiveSection] = useState('');

  useEffect(() => {
    const fetchAbout = async () => {
      const aboutDoc = await getDoc(doc(db, 'about', 'main'));
      if (aboutDoc.exists()) {
        const data = aboutDoc.data();
        setTitle(data.title || '');
        setDescription(data.description || '');
        setSections(data.sections || []);
        setAboutText(data.aboutText || '');
        setImageUrl(data.imageUrl || '');
      }

      setTimeout(() => {
        animateSections();
      }, 1000);
    };

    fetchAbout();
  }, [parentScroller]);


  const animateSections = () => {
    // if (footerRef.current) {
    //   const curr = footerRef.current;
    //   gsap.set(curr.querySelector(`.${footerStyles.footer}`), { marginTop: '40px'})
    //   gsap.to(curr.querySelector(`.${footerStyles.footer}`), { opacity: 1, duration: 0.5, delay: 0.5 });
    // }
  };


  const renderHighlightText = (text) => {
    return text.split(' ').map((word, index) => {
      if (word.toLowerCase() === 'create' || word.toLowerCase().includes('dwell')) {
        return (
          <span key={index} className={styles.highlight}>
            {word}&nbsp;
          </span>
        );
      }
      return word + ' ';
    });
  };

  const renderHighlightPrepositions = (text) => {
    const prepositions = [
      // 'yet', 'between', 'of', 'the', '+', 'are', 'is',
    ];

    return text.split(' ').map((word, index) => {
      if (prepositions.includes(word.trim().toLowerCase())) {
        return (
          <span key={'word_' + index} className={styles.highlight}>
            {word}&nbsp;
          </span>
        );
      }
      return word + ' ';
    });
  };

  const closeSectionInfo = (e) => {
    e.stopPropagation();
    setActiveSection(null);
    clearActiveCircle(e);
    clearServiceTooltip(e);
  };

  const handleSlideClick = (index) => {
    if (swiperInstance) {
      swiperInstance.slideTo(index);
    }
  };

  const renderHighlightAbout = (text) => {
    const prepositions = [
      // 'architect', 'carolina', 'wiebe', "carolina's",
    ];

    return text.split(' ').map((word, index) => {
      if (prepositions.includes(word.trim().replace('.', '').replace(',', '').replace('(', '').replace(')', '').toLowerCase())) {
        return (
          <span key={'word_' + index} className={styles.highlight}>
            {word}&nbsp;
          </span>
        );
      }
      return word + ' ';
    });
  };

  const setActiveCircleAnimate = (circle) => {
    setActiveCircle(circle);
    setTimeout(() => {
      gsap.fromTo(animatedContentRef.current, {
        opacity: 0, x: 0
      },
        { opacity: 1, x: 100, duration: 0.3 });
    }, 100);
  }

  const [activeCircle, setActiveCircle] = useState(null);

  const circleLabels = [
    { id: 1, label: 'Structural Engineer', description: 'Engineers site, civil, and landscape structures.  May be assigned role of special inspector. (privacy walls, retaining walls, generator supports and dumpster enclosures.)' },
    { id: 2, label: 'Mechanical Engineer', description: 'Engneers & specifies the mechanical systems & equipment for heating, ventilating, and air conditioning (HVAC.)' },
    { id: 3, label: 'Electrical Engineer', description: 'Engineers & specifies the electrical systems & equipment for power, lighting, and communications.' },
    { id: 4, label: 'Plumbing Engineer', description: 'Engineers & specifies plumbing systems & equipment for potable water, sewer waste, storm drainage, and fire supression.' },
    { id: 5, label: 'Civil Engineer', description: 'Engineers & specifies the infrastructure systems & equipment related to paving, grading, utilties (water & sewer), drainage & stormater management, and environmental control (e.g. erosion.)' },
    { id: 6, label: 'Landscape Architect', description: 'Designs & specifies systems and materials for planting, hardscape, and irrigation systems' },
    { id: 7, label: 'Specialty Consultants', description: 'Provides niche expertise for projects. (Cost Estimating.)' },
  ];

  const clearActiveCircle = (e) => {
    e.stopPropagation();
    setActiveCircle(null);
    gsap.fromTo(animatedContentRef.current, {
      opacity: 1, x: 100
    },
      { opacity: 0, x: 0, duration: 0.3 });
  }


  const [activeService, setActiveService] = useState(null);
  const serviceContentRef = useRef(null);
  const serviceLabels = [
    { id: 1, label: 'Pre-Design', description: 'Research & strategic planning for projects with timelines and goals.' },
    { id: 2, label: 'Schematic Design', description: 'Architectural and interior design solutions. 2D and 3D Concept.' },
    { id: 3, label: 'Design Development', description: 'Specifications of equipment, appliances, fixtures, cabinetry/millwork, materials, and finishes' },
    { id: 4, label: 'Construction Documents', description: 'Permit Set.' },
    { id: 5, label: 'Bidding & Negotiation', description: 'Delivering the final product to the client.' },
    { id: 6, label: 'Construction Administration', description: 'Providing support and upkeep post-project completion.' }
  ];
  const handleServiceClick = (service) => {
    setActiveService(service);
    setTimeout(() => {
      gsap.fromTo(serviceContentRef.current, { opacity: 0, y: -20 }, { opacity: 1, y: 0, duration: 0.2 });
    }, 100);
  };

  const clearServiceTooltip = (e) => {
    e.stopPropagation();
    setActiveService(null);
    gsap.to(serviceContentRef.current, { opacity: 0, y: -20, duration: 0.3 });
  };

  const SectionContent = ({ content, name }) => {
    return (
      <>
        {content.map((content, i) => {
          if (content.type === "paragraph") return <p key={'section_' + name + '_p_' + i} className={styles.paragraph}>{content.text}</p>;
          return null;
        })}
      </>
    );
  };

  return (
    <section className={styles.about} ref={aboutRef}>
      <div className={styles.container}>
        {/* <h1 className={styles.title}>About us</h1> */}
        <div className={styles.aboutContent}>
          <h1 className={styles.heading}>{renderHighlightText(title)}</h1>
          <p className={styles.aboutParagraph}>{renderHighlightAbout(description)}</p>
        </div>
      </div>
      <section className={styles.container}>
        <section className={styles.section} key='section_why'>
          <h1 className={styles.title}>Why</h1>
          <div className={styles.sectionContentContent}>
            <div>
              <h2 className={styles.subtitle}>Intention</h2>
              <div className={styles.gridContainer}>
                <div className={styles.textContent}>
                  <div className={styles.content}>
                    <p className={styles.paragraph}>We care what architecture conveys about you and your community. Through architecture, people are sheltered, places are defined, things are contained, information is conveyed, time is recorded.</p>
                    <p className={styles.paragraph}>You play a role in HOW this happens. We enjoy sharing part in that process with you! Together, we assume accountability in shaping your community, beginning with architecture that projects values important to YOU!</p>
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.aboutGraphicBox}>
              <IntentionGraphic />
            </div>
          </div>
        </section>
        <section className={styles.section} key='section_what'>
          <h1 className={styles.title}>What</h1>
          <div className={styles.sectionContentContent}>
            <div>
              <h2 className={styles.subtitle}>Identification</h2>
              <div>
                <p className={styles.paragraph}>
                  Our projects draw from and serve their surrounding context, 
                  evolving into landmarks within their communities and projecting the identity of their commissioning patrons. 
                </p>
                <p className={styles.paragraph}>
                  Within our studio, architectural design is an intentional act of gathering: 
                  thoughts and dreams, space and place, material and technology, efficiency and economy.
                </p>
                <p className={styles.paragraph}>
                  We identify the unique balance of these interchangeable criteria in every design.
                </p>
              </div>
            </div>
            <div className={styles.aboutGraphicBox}>
              <IdentificationGraphic />
            </div>
            <div className={styles.aboutGraphicBox}>
              <IntegrationGraphic />
            </div>
            <div>
              <h2 className={styles.subtitle}>Integration</h2>
              <p className={styles.paragraph}>
                We ensure the viability of your project by sensitively integrating your specific needs, wants, budget;
                the multi-dimensional factors of your site; 
                the dynamics of the local construction industry; 
                and the synergy between quality, size, and cost.
              </p>
            </div>
          </div>
        </section>
        <section className={styles.section} key='section_how'>
          <h1 className={styles.title}>How</h1>
          <div className={styles.sectionContentContent}>
            <div>
              <h2 className={styles.subtitle}>Implementation</h2>
              <p className={styles.paragraph}>
                We implement a design process where design criteria are:
                constraints, yet catalysts for creativity;
                defined, yet not pre-conceived;
                established, yet expected to change.
              </p>
              <p className={styles.paragraph}>
                This process results in projects that reveal a strong sense of belonging to a place:
                minimal, yet essential;
                beautiful, yet transcending fashion and decoration;
                impactful, yet environmentally sensitive.
              </p>
              {/* <p className={styles.paragraph} style={{ fontWeight: 'bold' }}>
                Learn about{' '}
                <Link to="/#services" style={{ color: 'var(--color-link)', textDecoration: 'underline', fontWeight: 'bold' }}>
                  our services
                </Link>
                .
              </p> */}
            </div>
            <div className={styles.aboutGraphicBox}>
              <ImplementationGraphic />
            </div>
          </div>
        </section>
        <section className={styles.section} key='section_who'>
          <h1 className={styles.title}>Who</h1>
          <div className={styles.sectionContentContent}>
            <div>
              <h2 className={styles.subtitle}>Team</h2>
              <p>
                As the architect, <span style={{fontFamily: "Poiret One", fontSize: "17.5px"}}>create-dwell</span> identifies the design & engineering professionals most appropriate for your project.
                As Team Lead, <span style={{fontFamily: "Poiret One", fontSize: "17.5px"}}>create-dwell</span> oversees the coordination of all disciplines involved in your design.
                This provides you with one point-of-contact, your project manager at <span style={{fontFamily: "Poiret One", fontSize: "17.5px"}}>create-dwell</span>.
              </p>
            </div>
            <div className={styles.aboutGraphicBox}>
              <WhoGraphic />
              <p>
                *Common specialty consultants available for services related to: acoustics , audio/visual, communications, cost estimating, food service, indoor air quality, security, smart home, surveying, testing + engineering, traffic, and value engineering.
              </p>
            </div>
            <div className={styles.aboutImageContainer}>
              <img className={styles.aboutImage} src={imageUrl} alt="About" />
            </div>
            <div>
              <p style={{ textAlign: 'justify' }}>
              As an architect and interior designer registered in the state of Florida, Carolina Wiebe has been recognized by local and state levels of the American Institute of Architects for her award-winning designs.
              Certified by the United States Green Building Council (USGBC) as an accredited professional in Leadership in Energy and Environmental Design (LEED AP), her specialty is in Building Design and Construction (BD+C).
              With a body of work in Florida, Mexico, and Canada, Carolina's professional experience ranges from large scale cultural institutions and master planning to small scale financial institutions and residences.
              By-products of her work include consensus building and visioning, furniture design, and graphic design.
              Carolina looks forward to future opportunities, applying her expertise to projects of varying uses, scales, and scopes, especially within zones of high velocity wind speeds – ready to address the needs of clients seeking one-of-a-kind projects that respond to and work with their local environments.
              </p>
            </div>
          </div>
        </section>
      </section>
    </section>
  );
};

export default About;